import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAllCouriers,
  selectCouriersState,
} from '../redux-toolkit/slice/onboardingSlice';
import {
  fetchAllProducts,
  selectProductState,
} from '../redux-toolkit/slice/ProductSlice';
import {
  fetchAllProductTypes,
  selectProductTypeState,
} from '../redux-toolkit/slice/ProductTypeSlice';
import { fetchMenu } from '../redux-toolkit/slice/menuSlice';
import { fetchTeamsDDL } from '../redux-toolkit/slice/teamsSlice';
import {
  clearPreviewSession,
  isPreviewTabActive,
} from '../common/helper/tokenStorage';
const useStoreInitializer = (token, persistedState, initializeStore) => {
  const dispatch = useDispatch();
  const couriersState = useSelector(selectCouriersState);
  const productState = useSelector(selectProductState);
  const productTypeState = useSelector(selectProductTypeState);
  const menu = useSelector((state) => state.menu);
  const teams = useSelector((state) => state.teams);

  useEffect(() => {
    if (!token && !persistedState) {
      if (isPreviewTabActive()) {
        clearPreviewSession();
      } else {
        localStorage.clear();
      }
    }
  }, [token, persistedState]);

  useEffect(() => {
    if (token && !couriersState?.hasFetched) {
      dispatch(fetchAllCouriers(token));
    }
  }, [token, couriersState?.hasFetched, dispatch]);

  useEffect(() => {
    if (token && !productState?.hasFetched && initializeStore) {
      dispatch(fetchAllProducts({ token }));
    }
  }, [token, productState?.hasFetched, dispatch, initializeStore]);

  useEffect(() => {
    if (token && !productTypeState?.hasFetched) {
      dispatch(fetchAllProductTypes(token));
    }
  }, [token, productTypeState?.hasFetched, dispatch]);

  useEffect(() => {
    if (
      token &&
      menu?.items?.length === 0 &&
      menu?.status !== 'loading' &&
      menu?.status !== 'failed'
    ) {
      dispatch(fetchMenu(token));
    }
  }, [token, menu?.items?.length, menu?.status, dispatch]);

  useEffect(() => {
    if (token && !teams?.hasFetched) {
      dispatch(fetchTeamsDDL(token));
    }
  }, [token, teams?.hasFetched, dispatch]);
};

export default useStoreInitializer;
